import { BaseEvent } from '../../../../../domain/event/base-event';
export class AssetClassEvent extends BaseEvent {
    constructor({ subject, type, payload, metadata, fromPersistence, }) {
        metadata = {
            aggregatename: 'AssetClass',
            ...metadata,
        };
        super({
            subject,
            type,
            payload,
            metadata,
            fromPersistence,
        });
    }
}
//# sourceMappingURL=asset-class.event.js.map